import * as THREE from 'three'
import { useGLTF, useTexture, Text, Sparkles, Clouds, Cloud } from '@react-three/drei'

export default function Jake() 
{
    // Jake
    const { nodes } = useGLTF('/Model/jake.glb')
    const jakeTexture = useTexture('./Model/Bake2.jpg')
    jakeTexture.colorSpace = THREE.SRGBColorSpace
    jakeTexture.flipY = false

    // Ground Textures
    const texturePaths = {
        map: './Texture/Ground038_2K-JPG_Color.jpg',
        normalMap: './Texture/Ground038_2K-JPG_NormalGL.jpg',
        roughnessMap: './Texture/Ground038_2K-JPG_Roughness.jpg',
        aoMap: './Texture/Ground038_2K-JPG_AmbientOcclusion.jpg',
    }

    const groundTextures = useTexture(texturePaths)

    Object.values(groundTextures).forEach(texture => 
    {
        texture.repeat.set(2.5, 2.5)
        texture.wrapS = texture.wrapT = THREE.RepeatWrapping
    })

    return (
        <>
            <mesh 
                geometry={nodes.jake.geometry}
                scale={1}
                rotation-y={1.5}
                position-y={ - 0.5}
            >
                <meshBasicMaterial map={jakeTexture} />
            </mesh>

            <mesh
                rotation={[-Math.PI / 2, 0, -0.2]}
                position={[0, - 0.5, -0.5]}
            >
                <planeGeometry args={[5, 5]} />
                <meshStandardMaterial {...groundTextures} />
            </mesh>

            <Text
                font='./Font/just-another-hand-v20-latin-regular.woff'
                fontSize={ 0.25 }
                position={[ 0.1, 0.51, - 1.005 ]}
                rotation={[ 0, 0.21, 0.3 ]}
                color={ '#000000' }
            >
                MY
            </Text>

            <Text
                font='./Font/just-another-hand-v20-latin-regular.woff'
                fontSize={ 0.2 }
                position={[ 0.12, 0.2, - 1.05 ]}
                rotation={[ 0.1, - 0.09, 0.1 ]}
                color={ '#000000' }
            >
                BURRITO
            </Text>

            <Sparkles
                size={ 3 }
                scale={[ 5, 2, 5 ]}
                position={[ 0, 0.5, - 0.5 ]}
                speed={ 0.5 }
                count={ 200 }
            />

            <Clouds material={THREE.MeshBasicMaterial}>
                <Cloud 
                    segments={ 4 } 
                    bounds={[ 1, 0, 0 ]} 
                    volume={ 0.2 } 
                    color='#472f89'
                    position={[ 2.2, 2, - 2.5 ]}
                /> 
                <Cloud 
                    segments={ 4 } 
                    bounds={[ 1, 0, 0 ]} 
                    volume={ 0.2 } 
                    color='#2b0b75'
                    fade={ 20 }
                    position={[ - 1.5, 1.5, - 2.5 ]}
                /> 
                <Cloud 
                    seed={ 2 } 
                    scale={ 0.5 } 
                    volume={ 5 } 
                    color='#7936dd' 
                    fade={ 50 }
                    position={[ 0, 1.7,  0 ]} 
                />
                <Cloud 
                    seed={ 5 } 
                    scale={ 0.5 } 
                    volume={ 5 } 
                    color='#662588' 
                    fade={ 70 }
                    position={[ 0, 2.3,  2.5 ]} 
                />
            </Clouds>


        </>
    )
}
